<div class="seed-return-add-prod productLineDelIns" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Maintain Delivery Instructions to Request
    </h3>
  </div>
  <div class="row tabBgColor ">
    <div class="col-md-9">
    </div>
    <div class="col-md-3 showBtnwithZindex">
      <button [disabled]="!isDeliveryInstrcutionAccess" id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" (click)="onAddProduct()" data-testid="btn-add-delivery-instruction">Add Row</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head" id="divAccountTab">
              <h4>
                Delivery Instructions
              </h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable addProductsSeedFulfillment">
            <div class="OrderReleaseDetail">
              <div class="row">
                <div class="col-md-12 productTableOuter">
                  <div class="tableContainer">
                    <table mat-table [dataSource]="deliveryInstructionDS" multiTemplateDataRows
                           class="matTables productTable">
                      <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                        <div *ngIf="column=='edit'">
                        <th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity "></th>
                  </div>
                  <div *ngIf="column=='select'">
          <th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity "></th>
    </div>

    <div *ngIf="column=='productLine'">
      <th mat-header-cell *matHeaderCellDef class="prod-name">Product Line*</th>
    </div>
    <div *ngIf="column=='contactType'">
      <th mat-header-cell *matHeaderCellDef class="total-units text-center">Contact Type*</th>
    </div>
    <div *ngIf="column=='firstName'">
      <th mat-header-cell *matHeaderCellDef class="total-units text-center">First Name*</th>
    </div>
    <div *ngIf="column=='lastName'">
      <th mat-header-cell *matHeaderCellDef class="total-units text-center">Last Name*</th>
    </div>
    <div *ngIf="column=='phone'">
      <th mat-header-cell *matHeaderCellDef class="total-units text-center">Phone #*</th>
    </div>
    <div *ngIf="column=='emailAddress'">
      <th mat-header-cell *matHeaderCellDef class="total-units text-center">
        Email Address*
      </th>
    </div>
    <div *ngIf="column=='deliveryInstructions'">
      <th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity ">
        Delivery
        Instructions
      </th>
    </div>
    <div *ngIf="column=='action'">
      <th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity "></th>
    </div>
    <div *ngIf="column=='sarEmail'">
    <th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity ">SAR Email</th>
    </div>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='edit' && isDeliveryInstrcutionAccess" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <i title="Edit Delivery Instruction" class="icon-ico-edit handCursor" [ngClass]="isDeliveryInstrcutionAccess ? 'enableBlue' : 'disableBlue'" (click)="editDeliveryInstruction(element.id)"></i>
          <!--<i title="Cancel Editing" class="icon-ico-Close handCursor hidden" (click)="editDeliveryInstruction(element.contactId)"></i>-->
        </div>
      </div>
      <div *ngIf="column=='select'" class="text-center">
        <div class="col-md-12 customerPO customerDI margin-b8">
          <input type="radio" name="item-di" [(ngModel)]="element.selectedDI" [disabled]="isRadioButtonDisabled || !isDeliveryInstrcutionAccess" [value]="element.contactId" (change)="setDeliveryInstruction(element)" />
        </div>
      </div>
      <div *ngIf="column=='productLine'" class="available-block text-center">
        <div class=" col-md-12 material-select withBordr">
          <ng-select name="ddlProductLine" [items]="productLineList"
                     [(ngModel)]="element.productLine" [clearable]="false" [searchable]="false"
                     class="custom-select-grower grower-add-drop" [virtualScroll]="true"
                     bindLabel="Description" bindValue="ProductLineId" [closeOnSelect]="true"
                     (change)="onInputChange(element,'productLine')"
                     data-testid="ddl-ship-to-search" [disabled]="element.isDisabled">
          </ng-select>
        </div>
      </div>
      <div *ngIf="column=='contactType'" class="available-block text-center">
        <div class=" col-md-12 material-select withBordr">
          <ng-select name="ddlContactType" [items]="contactTypeList"
                     [(ngModel)]="element.contactType" [clearable]="false" [searchable]="false"
                     class="custom-select-grower grower-add-drop" [virtualScroll]="true"
                     bindLabel="value" bindValue="id" [closeOnSelect]="true"
                     (change)="onInputChange(element,'contactType')"
                     data-testid="ddl-contact-type-search" [disabled]="element.isDisabled">
          </ng-select>
          <mat-error *ngIf="!element.isContactTypeValid">
            Please add primary contact first
          </mat-error>
        </div>
      </div>

      <div *ngIf="column=='firstName'" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <mat-form-field class="">
            <input matInput type="text"
                   name="firstName"
                   class="pb-1"
                   [(ngModel)]="element.firstName"
                   [maxLength]="25"
                   autocomplete="off"
                   required
                   (change)="onInputChange(element,'firstName')" [readonly]="element.isDisabled">
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="column=='lastName'" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <mat-form-field class="">
            <input matInput type="text"
                   name="lastName"
                   class="pb-1"
                   [(ngModel)]="element.lastName"
                   autocomplete="off"
                   [maxLength]="25"
                   required
                   (change)="onInputChange(element,'lastName')" [readonly]="element.isDisabled">
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="column=='phone'" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <mat-form-field class="">
            <input matInput type="text"
                   name="phone"
                   class="pb-1"
                   [(ngModel)]="element.phoneNumber"
                   autocomplete="off"
                   required
                   mask="000-000-0000"
                   (keyup)="validatePhone(element)"
                   [ngClass]="{valid : (element.isPhoneValid !=false)}"
                   (change)="onInputChange(element,'phone')" [readonly]="element.isDisabled">
            <mat-error *ngIf="!element.isPhoneValid">
              Phone number should be 10 digit.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="column=='emailAddress'" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <mat-form-field class="">
            <input matInput type="email"
                   required
                   name="emailAddress"
                   class="pb-1"
                   autocomplete="off"
                   [(ngModel)]="element.email"
                   [pattern]="emailPattern"
                   (keyup)="validateEmail(element)"
                   [readonly]="element.isDisabled"
                   [ngClass]="{valid : (element.isEmailValid !=false)}">
            <mat-error *ngIf="!element.isEmailValid">
              Email not valid.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="column=='deliveryInstructions'" class="text-center">
        <div class="col-md-12 material-select withBordr">
          <ng-select name="ddlDeliveryInstrucion" [multiple]="true"
                     [items]="deliveryInstructionList" [(ngModel)]="element.deliveryCodes"
                     [clearable]="false" [searchable]="false"
                     class="custom-select-grower grower-add-drop" [virtualScroll]="true"
                     bindLabel="DeliveryCode" bindValue="DeliveryCode"
                     [closeOnSelect]="true" (change)="onInputChange(element,'deliveryCodes')"
                     data-testid="ddl-ship-to-search" [disabled]="element.isDisabled">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" name="item-{{index}}"
                     [ngModel]="item$.selected" />
              {{item.Description}} ({{item.DeliveryCode}})
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div *ngIf="column=='action' && isDeliveryInstrcutionAccess" class="text-center">
        <div class="col-md-12 customerPO customerDI">
          <i title="delete" class="icon-ico-trash handCursor"
             (click)="deleteProducts(element)"></i>
        </div>
      </div>
      <div *ngIf="column === 'sarEmail'" class="text-center">
        <mat-checkbox class="custom-checkbox margin-l10"
                      [checked]="element.sarEmail === 'Y'"
                      (change)="onCheckboxChange(element.id, $event.checked)"
                      [disabled]="element.isDisabled">
        </mat-checkbox>
      </div>
    </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
    </table>
    <div *ngIf="deliveryInstructionDS?.data.length == 0" class="noDataMsg">
      <p class="padding-b47">No Record Found.</p>
    </div>
    <div class="row add-order-sec margin-l0 margin-r0 position-fixed">
      <div class="col-md-2 padding-l10">
        <button id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" (click)="saveDeliveryInstructions()" [disabled]="isSaveDisabled || !isDeliveryInstrcutionAccess" data-testid="btn-save-delivery-instructions">Save</button>
      </div>
      <div class="col-md-2 padding-l10">
        <button id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" (click)="selectDeliveryInstruction(null)" [disabled]="isSelectDIDisabled || !isDeliveryInstrcutionAccess" data-testid="btn-select-delivery-instructions">Select Delivery Instruction</button>
      </div>
      <!--<div class="col-md-2 padding-l0" *ngIf="isShowExportButton()">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()">Export</button>
    </div>
    <div class="col-md-8 text-right">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>-->
    </div>
  </div>
</div>
